import { useMutation } from 'react-query';

import { logout as mutationFn } from 'api/endPoints/logout';

export const useMutationLogout = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    token: string;
    username: string;
}
